import { Assert } from "@/common/Assert";
export function createCmi5UIAdapter(course) {
    Assert.checkArgument(course);
    // revealing public api
    return {
        /**
         * Gets the storage method for the course.
         *
         * @returns {String} storage method
         */
        getStorageMethod: function () {
            return "scorm2004";
        },
        /**
         * @deprecated
         */
        getMasteryScore: function (scoId) {
            const masteryScore = course.domStructure.getSequenceData(scoId).getMasteryScore();
            return Number(masteryScore) || 80;
        },
        getScore: function (scoId) {
            const score = course.getLesson(scoId).getScore();
            if (isNaN(score)) {
                return 0;
            }
            return score > 1 ? 100 : score * 100;
        },
        getLessonStatus: (scoId) => { var _a; return (_a = course.getLesson(scoId).getStatus()) !== null && _a !== void 0 ? _a : "unknown"; },
        getLessonLocation: (scoId) => { var _a; return (_a = course.getLesson(scoId).getLocation()) !== null && _a !== void 0 ? _a : "unknown"; },
        canResume: (scoId) => course.getLesson(scoId).canResume(),
        setUsername: function (name) {
            course.username = name;
        },
        getUsername: function () {
            return course.username;
        }
    };
}
